<template>
  <div class="modal fade" ref="pdfViewerModalRef">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 1500px;">
      <div class="modal-content" style="height: 90vh">
        <div class="modal-body p-0 m-0">
          <iframe
            v-if="urlPdf"
            :src="urlPdf"
            frameborder="0"
            class="w-100"
            style="height: 92vh"
            type="application/pdf"
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
export default {
  data() {
    return {
      modalRef: null,
      urlPdf: null,
      title: null,
    };
  },
  mounted() {
    this.modalRef = new Modal(this.$refs.pdfViewerModalRef);
  },
  methods: {
    show({ url, title }) {
      this.modalRef.show();
      this.urlPdf = url;
      this.title = title;
    },
    hide() {
      this.urlPdf = null;
      this.title = null;
      this.modalRef.hide();
    },
  },
};
</script>
